import { render, staticRenderFns } from "./order-detail-test.vue?vue&type=template&id=6320b9ac&scoped=true&"
import script from "./order-detail-test.vue?vue&type=script&lang=js&"
export * from "./order-detail-test.vue?vue&type=script&lang=js&"
import style0 from "./order-detail-test.vue?vue&type=style&index=0&id=6320b9ac&lang=scss&scoped=scoped&"
import style1 from "./order-detail-test.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6320b9ac",
  null
  
)

export default component.exports